// Dev-only error logging so production builds stay quiet while failures remain debuggable.
export const logError = (message, error) => {
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.error(message, error);
  }
};
